module.exports = __webpack_public_path__ + "static/img/1_1_2_3.146770c2.jpg";